import React from "react";
import { Link } from "react-router-dom";
import CustomerHeader from "../../components/CustomerHeader";
import CustomerFooter from "../../components/CustomerFooter";
import {
  PACKAGE_TERMS_PATH,
  PACKAGE_TERMS_SECTIONS,
  PACKAGE_TERMS_SUMMARY,
  PACKAGE_TERMS_VERSION,
} from "../../content/packageTerms";

/**
 * THE PACKAGE TERMS AS THE CUSTOMER READS THEM (user, 2026-10-14).
 *
 * *"I can't see the T&C being shown to the customers/guests when purchasing packages, this is really important if
 * not we can't enforce any of these on the customer/guest."*
 *
 * PUBLIC and not behind a sign-in: a guest buys a package without an account, and the person who most needs to
 * read the cancellation terms is a guest. A terms page nobody can open is the same as no terms page.
 *
 * The version is rendered at the bottom. It is what the purchase page sends back and what the server checks, so
 * a customer who quotes a date can be tied to the exact text they read.
 */
const PackageTerms = () => (
  <div className="package-terms-page">
    <CustomerHeader />

    <main
      style={{
        maxWidth: "760px",
        margin: "0 auto",
        padding: "24px 16px 64px",
        lineHeight: 1.6,
      }}
    >
      <h1 style={{ fontSize: "24px", marginBottom: "4px" }}>Package Terms</h1>
      <p style={{ color: "#6b7280", fontSize: "14px", marginTop: 0 }}>
        Terms version {PACKAGE_TERMS_VERSION}
      </p>

      <div
        style={{
          background: "#f0f9ff",
          border: "1px solid #bae6fd",
          borderRadius: "8px",
          padding: "14px 16px",
          margin: "16px 0 24px",
        }}
      >
        <h2 style={{ fontSize: "15px", margin: "0 0 8px 0", color: "#075985" }}>
          In short
        </h2>
        <ul style={{ margin: 0, paddingLeft: "20px", fontSize: "14px", color: "#0c4a6e" }}>
          {PACKAGE_TERMS_SUMMARY.map((line) => (
            <li key={line} style={{ marginBottom: "4px" }}>
              {line}
            </li>
          ))}
        </ul>
        <p style={{ fontSize: "12px", color: "#0c4a6e", margin: "8px 0 0 0" }}>
          The short version is a summary. The terms below are what you are agreeing to.
        </p>
      </div>

      {PACKAGE_TERMS_SECTIONS.map((section) => (
        <section key={section.heading} style={{ marginBottom: "22px" }}>
          <h2 style={{ fontSize: "16px", marginBottom: "6px" }}>{section.heading}</h2>

          {(section.paragraphs || []).map((paragraph) => (
            <p key={paragraph} style={{ fontSize: "14px", margin: "0 0 8px 0" }}>
              {paragraph}
            </p>
          ))}

          {section.table && (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                margin: "8px 0",
              }}
            >
              <tbody>
                {section.table.map(([what, cost]) => (
                  <tr key={what}>
                    <td
                      style={{
                        border: "1px solid #e5e7eb",
                        padding: "8px",
                        verticalAlign: "top",
                        width: "45%",
                      }}
                    >
                      {what}
                    </td>
                    <td
                      style={{
                        border: "1px solid #e5e7eb",
                        padding: "8px",
                        verticalAlign: "top",
                      }}
                    >
                      {cost}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      ))}

      <p style={{ fontSize: "13px", color: "#6b7280" }}>
        These terms are recorded with your purchase, along with the date you accepted them.
      </p>

      <p style={{ marginTop: "24px" }}>
        <Link to="/" style={{ color: "#1d4ed8", fontSize: "14px" }}>
          Back to OGESTYLE
        </Link>
      </p>
    </main>

    <CustomerFooter />
  </div>
);

export default PackageTerms;

/** The path the rest of the app links to, from one place. */
export { PACKAGE_TERMS_PATH };
